import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import { NavLink } from 'react-router-dom';

function SolutionforPharma() {
    return (
        <div>
            <Header />
            <div className="breadcrumbs overlay">
                <div className="container">
                    <div className="bread-inner">
                        <div className="row">
                            <div className="col-12">
                                <h2>Solution for Pharma Companies</h2>
                                <ul className="bread-list">
                                    <li><NavLink to='/'>Pricing</NavLink></li>
                                    <li><i className="icofont-simple-right" /></li>
                                    <li className="active">Solution for Pharma Companies</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="mission-section section">
                <div className="container">

                    <div className="row align-items-center">
                        {/* Text Content */}
                        <div className="col-lg-6 mb-lg-0" style={{ lineHeight: '1.8', fontSize: '1.1rem', color: '#333' }}>
                            <h3 className="text-primary mb-2" style={{ fontSize: '2rem' }}>Solution For Pharma Companies</h3>
                            <p style={{ textAlign: 'justify', fontSize: '14px', color: '#333' }}>
                                <strong>WEBNET TECHNOLOGIES</strong> has the responsibility for both establishing and protecting the overarching purpose, fundamental values and ethical principles which govern the activities of the organisation. These are often referred to as the vision, mission and values. Your vision, mission, and values form the foundation of your organisation and its planning for the future. Establishing the vision, mission and values is also an ongoing process of review to ensure that they are still relevant for the current challenges and environment. The Management Committee must ensure that the organisation operates in a way that is consistent with its vision, mission and values. This should be the basis for planning, monitoring and reviewing all activities, expenditures, policies and decision-making.
                            </p>
                            {/* <ul className="list">
                <li><i className="fa fa-caret-right"></i> Providing high-quality software and IT services through innovation and expertise.</li>
                <li><i className="fa fa-caret-right"></i> Promoting digital awareness and best practices to empower informed decisions.</li>
                <li><i className="fa fa-caret-right"></i> Ensuring accessibility and affordability for small to large-scale businesses.</li>
                <li><i className="fa fa-caret-right"></i>   Upholding transparency, ethics, and respect in every project and partnership.</li>

              </ul> */}

                            <p style={{ textAlign: 'justify', fontSize: '14px', color: '#333' }}>
                                Our organisation's vision & mission is the long-term change it ideally would like to see if its work is successful. A vision should motivate and enable individuals to see how their effort contributes to an overall inspirational purpose. It is the reason the group or organisation exists and helps keep everyone involved in the organisation focused. committee members need to be familiar with the vision, mission and values of the organisation and these need to be periodically reviewed in light of current and impending circumstances

                            </p>
                        </div>

                        {/* Image */}
                        <div className="col-lg-6 col-md-12">
                            <img
                                src="img/Solutionforphama.jpeg"
                                alt="Mission"

                            />
                        </div>
                    </div>

                </div>
            </section>
            <Footer />
        </div>
    )
}

export default SolutionforPharma
